<template lang="pug">
router-view
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: "ExpertPage",

  methods: {
    ...mapActions('expert', ['fetchRegions'])
  },

  mounted() {
    this.fetchRegions()
  }
}
</script>